import { render } from "./ProductImage.vue?vue&type=template&id=7d5e8d34&scoped=true&ts=true"
import script from "./ProductImage.vue?vue&type=script&lang=ts"
export * from "./ProductImage.vue?vue&type=script&lang=ts"

import "./ProductImage.vue?vue&type=style&index=0&id=7d5e8d34&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5e8d34"]])

export default __exports__